interface SkeletonProps {
  className?: string;
}

/** A single pulsing placeholder block. Pass sizing via className. */
export function Skeleton({ className = "" }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded bg-gray-200 motion-reduce:animate-none dark:bg-gray-800 ${className}`}
      aria-hidden="true"
    />
  );
}

export function CardSkeleton({ lines = 2 }: { lines?: number }) {
  return (
    <div className="rounded-lg border border-gray-200 p-3 dark:border-gray-800">
      <div className="flex items-center gap-2">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-4 w-16" />
      </div>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={`mt-2 h-3 ${i % 2 ? "w-1/2" : "w-3/4"}`} />
      ))}
    </div>
  );
}

export function ListSkeleton({ rows = 4, lines = 2 }: { rows?: number; lines?: number }) {
  return (
    <div className="space-y-2" role="status" aria-label="Loading">
      {Array.from({ length: rows }).map((_, i) => (
        <CardSkeleton key={i} lines={lines} />
      ))}
      <span className="sr-only">Loading…</span>
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div className="mx-auto w-full max-w-3xl p-4" role="status" aria-label="Loading">
      <Skeleton className="mb-4 h-5 w-40" />
      <ListSkeleton rows={5} />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
